import axios from '@/plugins/axios'

export default {
  fetch() {
    return axios.get('/countries')
      .then(response => {
        return response.data
      })
  },
  updateCountry(country) {
    return axios.patch(`/countries/${country.id}`, country)
      .then(response => {
        return response.data
      })
  },
  updateMargins(data) {
    return axios.post('/countries/update-margins', data).then(response => response.data)
  }
}
